import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LocaleSwitcher } from '@/components/LocaleSwitcher';
import { ThemeSwitcher } from '@/components/ThemeSwitcher';

export function TopBar() {
  const { t } = useTranslation('common');
  return (
    <header className="sticky top-0 z-40 flex h-14 items-center justify-between border-b border-border bg-background/95 px-4 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <Link to="/" className="flex items-center gap-2 font-semibold tracking-tight">
        <span className="grid h-7 w-7 place-items-center rounded-md bg-primary text-primary-foreground">
          F
        </span>
        <span>{t('app_name')}</span>
      </Link>
      <div className="flex items-center gap-1">
        <LocaleSwitcher />
        <ThemeSwitcher />
      </div>
    </header>
  );
}
